import { render } from "./SubmitCasePage.vue?vue&type=template&id=43c4e02c"
import script from "./SubmitCasePage.vue?vue&type=script&lang=js"
export * from "./SubmitCasePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__